/** @format */

import { Component, EventEmitter, Output } from "@angular/core";
import { Router } from "@angular/router";
import {
	AbstractControl,
	FormBuilder,
	FormControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators,
} from "@angular/forms";
import { ApiServiceService } from "src/app/Services/api-service.service";
import { FormService } from "../../form.service";
import { DatePipe } from "@angular/common";
import { lengthValidator } from "src/app/Shared/length-validator.service";
import alertify from "alertifyjs";
import { finalize } from "rxjs";

@Component({
	selector: "app-informal-asin-form",
	templateUrl: "./informal-asin-form.component.html",
	styleUrls: ["./informal-asin-form.component.css"],
	providers: [DatePipe],
})
export class InformalAsinFormComponent {
	cacForm: FormGroup;
	basicForm: FormGroup;
	otpForm: FormGroup;
	nbList = [];
	contactIsSameAsBusinessOwner: boolean = false;
	isCodeReady = false;
	isLoading = false;
	registeredWithCac: boolean = true;

	codeConfirmMSG = "";
	emailPhone = "";
	isSendingOTPtoEmail: boolean = false;
	isSendingOTPtoSMS: boolean = false;

	emailExists = false;

	isVerifyingCAC = false;
	isVerifyingOTP = false;

	cacVerified: boolean = false;
	isSubmitting: boolean = false;

	countdownSeconds: number = 30;
	countdownTimer: any;
	isCountDown: boolean = false;

	otpVerificationType: string;
	allowSubmission: boolean = false;
	constructor(
		private apiServer: ApiServiceService,
		private formService: FormService,
		private fb: FormBuilder,
		private datePipe: DatePipe,
		private router: Router,
	) {}
	state: any;
	state2: any;
	lga: any;
	areas: any;

	isInPreviewMode: boolean = false;
	isInEditingMode: boolean = true;
	isCheckingIfEmailExists: boolean = false;
	screenHeight = window.screen.height - 271; // 1058
	minHeight = "min-height: " + this.screenHeight + "px !important";

	screenHeight2 = window.screen.height - 630; // 428
	minHeight2 = "min-height: " + this.screenHeight2 + "px !important";

	ngOnInit() {
		this.fetchNaturesOfBusiness();

		this.otpForm = this.fb.group({
			otp: ["", Validators.required],
		});

		this.cacForm = this.fb.group({
			cac: ["", Validators.required],
			companyName: [""],
		});
		this.basicForm = this.fb.group({
			// Business Information
			registeredWithCac: [true, Validators.required],
			corporateName: ["", Validators.required],
			dateOfCommencement: ["", Validators.required],
			businessContactEmail: ["", [Validators.required, Validators.email]],
			businessContactPhoneNumber: [
				"",
				[Validators.required, this.phoneNumberValidator],
			],
			ownershipType: ["", Validators.required],
			natureOfBusiness: ["", Validators.required],
			numberOfBranches: [1, [Validators.required, Validators.min(0)]],
			numberOfEmployees: [, [Validators.required, Validators.min(0)]],
			averageStaffSalary: [, Validators.min(0)],
			vehicleCount: [, [Validators.required, lengthValidator(5, 50)]],
			businessState: [, Validators.required],
			businessLga: [, Validators.required],
			businessArea: [],
			businessAddress: ["", Validators.required],
			isBusinessAddressRented: [true, Validators.required],

			// Business Owner Details
			firstName: ["", Validators.required],
			lastName: ["", Validators.required],
			ownerAsin: ["", Validators.required],
			gender: ["", Validators.required],
			email: ["", [Validators.required, Validators.email]],
			phoneNumber: ["", [Validators.required, this.phoneNumberValidator]],

			// Contact Person Information
			contactFirstName: ["", Validators.required],
			contactLastName: ["", Validators.required],
			contactEmail: ["", [Validators.required, Validators.email]],
			contactPhoneNumber: [
				"",
				[Validators.required, this.phoneNumberValidator],
			],
			contactDesignation: ["", Validators.required],
			contactAddress: [""],

			// Additional Information
			solelyOnline: [false, Validators.required],
			estimatedRevenue: [, [Validators.required, Validators.min(0)]],
			hasAccessToFinancing: [false, Validators.required],
			password: ["", [Validators.required, this.passwordValidator()]],
			confirmPassword: [
				"",
				[Validators.required, this.passwordMatchValidator("password")],
			],
		});

		// this.populateForm();

		this.getState();
		this.getState2();
	}

	populateForm() {
		this.basicForm.patchValue({
			registeredWithCac: true,
			corporateName: "ONICHA DEVELOPMENT LTD",
			dateOfCommencement: "2024-28-10",
			businessContactEmail: "oasis@oasismgt.net",
			businessContactPhoneNumber: "09066667777",
			ownershipType: "SOLE-PROPIETORSHIP",
			natureOfBusiness: "INCORPORATED_TRUSTEE",
			numberOfBranches: 1,
			numberOfEmployees: 234,
			averageStaffSalary: 34,
			vehicleCount: 234,
			businessState: "27",
			businessLga: "95",
			businessArea: "12345",
			businessAddress: "dkefas@oasismgt.net",
			isBusinessAddressRented: true,
			firstName: "dekaf",
			lastName: "kefas",
			ownerAsin: "2345",
			gender: "MALE",
			email: "dekeji1@gmail.com",
			phoneNumber: "098765",
			contactFirstName: "dekaf",
			contactLastName: "kefas",
			contactEmail: "dekeji1@gmail.com",
			contactPhoneNumber: "098765",
			contactDesignation: "Business Owner",
			contactAddress: "45678",
			solelyOnline: false,
			estimatedRevenue: 34567,
			hasAccessToFinancing: true,
			password: "#Paula2002",
			confirmPassword: "#Paula2002",
		});
	}
	logValue() {
		if (this.contactIsSameAsBusinessOwner) {
			const businessOwnerDetails = {
				contactFirstName: this.basicForm.get("firstName")?.value,
				contactLastName: this.basicForm.get("lastName")?.value,
				contactEmail: this.basicForm.get("email")?.value,
				contactPhoneNumber: this.basicForm.get("phoneNumber")?.value,
				contactDesignation: "Business Owner",
				contactAddress: this.basicForm.get("address")?.value,
			};
			this.basicForm.patchValue(businessOwnerDetails);
		}
	}

	fetchNaturesOfBusiness() {
		this.apiServer
			.LoginGet("/auth/nature_of_business/all", {})
			.subscribe((res) => {
				console.log("natures", res);
				this.nbList = res;
			});
	}

	getState2() {
		this.apiServer.LoginGet("/auth/state/all", {}).subscribe((res) => {
			this.state2 = res;
		});
	}
	getState() {
		this.apiServer.LoginGet("/auth/state/all", {}).subscribe((res) => {
			this.state = res;
		});
	}

	goBackToEditingMode() {
		this.isInPreviewMode = false;
		this.isInEditingMode = true;
		this.basicForm.enable();
	}

	goToPreviewMode() {
		this.isInPreviewMode = true;
		this.isInEditingMode = false;
		this.basicForm.disable();
	}
	public getLga() {
		const selectedState = this.basicForm.value.businessState;
		if (selectedState) {
			this.apiServer
				.LoginGet(
					`/auth/lga/state/all/${this.basicForm.value.businessState}`,
					{},
				)
				.subscribe((res) => {
					this.lga = res;
				});
		} else {
			console.warn("no state selected");
		}
	}

	public getArea() {
		const selectedState = this.basicForm.value.businessState;
		const selectedLGA = this.basicForm?.value?.businessLga;

		if (selectedLGA && selectedState == 6) {
			this.apiServer
				.LoginGet(`/auth/area/all/${selectedLGA}`, {})
				.subscribe((res) => {
					this.areas = res;
				});
		} else {
			this.areas = [];

			console.warn(
				"only areas in LGAs in Anambra State are pre-loaded, please enter your Area manually. Thanks. ",
			);
		}
	}

	clearCacData() {
		this.patchCacDetail(null);
	}

	patchCacDetail(cacDetails: any) {
		const registratIonDate = new Date(cacDetails?.registrationDate);
		let formattedtDate = isNaN(registratIonDate.getTime())
			? null
			: this.datePipe.transform(registratIonDate, "yyyy-MM-dd");

		this.basicForm.patchValue({
			corporateName: cacDetails?.entityName,
			dateOfCommencement: formattedtDate,
			businessContactEmail: cacDetails?.email,
			businessContactPhoneNumber: cacDetails?.phoneNumber,
		});
	}

	verifyCAC() {
		this.isVerifyingCAC = true;
		let cac = this.cacForm.get("cac").value;
		let companyName = this.cacForm.get("companyName").value;
		const payload = {
			rcNumber: cac,
		};

		if (companyName) {
			payload["entityName"] = companyName;
		}

		this.apiServer
			// .postUser("/auth/utility/validate/cac?rcNumber=" + cac, {})
			.postUser("/assessments/vas-company-validation-rc", payload)
			.subscribe({
				next: (res) => {
					this.isVerifyingCAC = false;
					this.patchCacDetail(res?.data);
					// console.log(res);
					if (res) {
						this.cacVerified = true;
					} else {
						this.cacVerified = false;
						this.cacForm
							.get("cac")
							.setErrors({ invalidBusinessNumber: true });
					}
				},
				error: (error) => {
					this.isVerifyingCAC = false;
					alertify.set("notifier", "position", "top-center");
					alertify.error(
						"Verification failed, Please try again later",
					);
				},
			});
	}

	// async TChannel(t) {
	//   this.isLoading = true;
	//   this.startCountdown();
	//   this.emailPhone = t;
	//   let email = this.basicForm.get("businessContactEmail").value;
	//   let phoneNumber = this.basicForm.get("businessContactPhoneNumber").value;

	//   let request = {
	//     email: email,
	//     phoneNumber: phoneNumber,
	//     messageType: this.emailPhone,
	//   };

	//   this.apiServer
	//     .loginPost_("/auth/enumeration/send/code", request)
	//     .subscribe({
	//       next: (res) => {
	//         this.isLoading = false;
	//         this.isCodeReady = true;
	//         res.message;
	//         if (
	//           res.message.includes(email.toLowerCase()) ||
	//           res.message.includes(phoneNumber)
	//         ) {
	//           alertify.set("notifier", "position", "top-center");
	//           alertify.success(res?.message);
	//         } else {
	//           alertify.set("notifier", "position", "top-center");
	//           alertify.error(res?.message);
	//         }
	//       },
	//       error: (error) => {
	//         this.isLoading = false;
	//         alertify.set("notifier", "position", "top-center");
	//         alertify.error("Something went wrong");
	//       },
	//     });
	// }

	sendOTPtoEmail() {
		let email = this.basicForm.get("businessContactEmail").value;
		if (email) {
			let request = {
				email: this.basicForm.get("businessContactEmail").value,
				messageType: "email",
			};

			this.apiServer
				.loginPost_("/auth/enumeration/send/code", request)
				.subscribe({
					next: (res) => {
						this.isSendingOTPtoEmail = false;
						this.isCodeReady = true;
						res.message;
						if (res.message.includes(email.toLowerCase())) {
							alertify.set("notifier", "position", "top-center");
							alertify.success(res?.message);
							this.otpVerificationType = "email";
						} else {
							alertify.set("notifier", "position", "top-center");
							alertify.error(res?.message);
						}
					},
					error: (error) => {
						this.isSendingOTPtoEmail = false;
						alertify.set("notifier", "position", "top-center");
						alertify.error("Something went wrong");
					},
				});
		}
	}

	sendOTPtoSMS() {
		let phoneNumber = this.basicForm.get(
			"businessContactPhoneNumber",
		).value;

		if (phoneNumber) {
			this.isSendingOTPtoSMS = true;

			let request = {
				phoneNumber: this.basicForm.get("businessContactPhoneNumber")
					.value,
				messageType: "sms",
			};
			this.apiServer
				.loginPost_("/auth/enumeration/send/code", request)
				.subscribe({
					next: (res) => {
						this.isSendingOTPtoSMS = false;
						this.isCodeReady = true;
						res.message;
						if (res.message.includes(phoneNumber.toLowerCase())) {
							alertify.set("notifier", "position", "top-center");
							alertify.success(res?.message);
							this.otpVerificationType = "sms";
						} else {
							alertify.set("notifier", "position", "top-center");
							alertify.error(res?.message);
						}
					},
					error: (error) => {
						this.isSendingOTPtoSMS = false;
						alertify.set("notifier", "position", "top-center");
						alertify.error("Something went wrong");
					},
				});
		}
	}

	startCountdown() {
		this.countdownSeconds = 30;
		this.countdownTimer = setInterval(() => {
			if (this.countdownSeconds > 0) {
				this.isCountDown = true;
				this.countdownSeconds--;
			} else {
				this.isCountDown = false;
				clearInterval(this.countdownTimer);
			}
		}, 1000);
	}
	ngOnDestroy() {
		clearInterval(this.countdownTimer);
	}

	passwordValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value || "";
			const errors: ValidationErrors = {};

			if (value.length > 0) {
				if (value.length < 8) {
					errors["tooShort"] = true;
				}

				if (!/[A-Z]/.test(value)) {
					errors["missingUppercase"] = true;
				}

				if (!/[0-9]/.test(value)) {
					errors["missingNumber"] = true;
				}

				if (!/[!@#$%^&*()_+]/.test(value)) {
					errors["missingSpecialCharacter"] = true;
				}
			}

			return Object.keys(errors).length > 0 ? errors : null;
		};
	}

	passwordMatchValidator(passwordControlName: string) {
		return (control: AbstractControl): ValidationErrors | null => {
			const password = this.basicForm?.get(passwordControlName);
			const confirmPassword = control;

			if (
				password &&
				confirmPassword.value.length > 0 &&
				confirmPassword &&
				password.value !== confirmPassword.value
			) {
				return { passwordMismatch: true };
			}
			return null;
		};
	}

	phoneNumberValidator(control: AbstractControl): ValidationErrors | null {
		if (!control.value) {
			return null; // Let the `required` validator handle empty values.
		}
		const phoneRegex = /^(?:\+234|0)[789]\d{9}$/; // Matches Nigerian phone numbers
		const isValid = phoneRegex.test(control.value);
		return isValid ? null : { invalidPhoneNumber: true };
	}

	nextStep() {
		console.log(this.basicForm.value);
		this.goToPreviewMode();
	}

	verifyOTP() {
		if (this.otpVerificationType) {
			this.isVerifyingOTP = true;

			const email = this.basicForm.get("businessContactEmail").value;
			const phoneNumber = this.basicForm.get(
				"businessContactPhoneNumber",
			).value;
			this.apiServer
				.loginPost_("/auth/enumeration/confirm/code", {
					email,
					phoneNumber,
					code: this.otpForm.value.otp,
					messageType: this.otpVerificationType,
				})
				.pipe(
					finalize(() => {
						this.isVerifyingOTP = false;
					}),
				)
				.subscribe((res) => {
					if (res.message.includes("Success")) {
						this.codeConfirmMSG = res.message;
						console.log(
							this.otpVerificationType == "sms"
								? phoneNumber
								: email + " verified successfully",
						);
						alertify.set("notifier", "position", "top-center");
						alertify.success(
							(this.otpVerificationType == "sms"
								? phoneNumber
								: email) + "verified successfully",
						);
						this.allowSubmission = true;
					} else {
						this.isSubmitting = false;
						this.codeConfirmMSG = res.message;
						alertify.set("notifier", "position", "top-center");
						alertify.error("invalid otp");
					}
				});
		}
	}

	onSubmit() {
		this.isSubmitting = true;
		const businessArea = this.basicForm.value?.businessArea;

		const isListOfAreasAvailable = Boolean(
			this.areas && this.areas.length > 0,
		);

		const request = {
			...this.basicForm.value,
			rcNumber: this.cacForm.value.cac,
			...(!isListOfAreasAvailable && {
				businessAreaName: businessArea,
				businessArea: undefined,
			}),
		};
		this.apiServer
			.loginPost_("/auth/enumeration/informal/save", request)
			.subscribe({
				next: (res) => {
					this.isSubmitting = false;
					const { data, success, message } = res;
					if (success) {
						alertify.set("notifier", "position", "top-center");
						alertify.success(data?.message);
						this.router.navigate(["/create-asin/code-successful"], {
							queryParams: { asin_no: data?.asin },
						});
					} else {
						alertify.set("notifier", "position", "top-center");
						alertify.error(message);
					}
				},

				error: (error) => {
					this.isSubmitting = false;
					alertify.set("notifier", "position", "top-center");
					alertify.error("Something went wrong");
				},
			});

		console.log(this.basicForm.value);
	}

	cancel() {
		this.router.navigate(["/create-asin"]);
	}

	back() {
		this.isInPreviewMode = false;
	}

	emailExist(control: AbstractControl) {
		this.isCheckingIfEmailExists = true;
		let url = "/auth/utility/user/exist/email?email=" + control.value;
		if (control.valid) {
			this.apiServer.LoginGet(url).subscribe((res) => {
				if (res == true) {
					control.setErrors({ emailAlreadyInUse: true });
				}
				this.isCheckingIfEmailExists = false;
			});
		}
	}
}
